import { Form } from "formik";
import React, { Component } from "react";

import {
  BASIC_SCHEMA,
  PATIENT_BASIC_SCHEMA,
  PREFERRED_NAME_SCHEMA_PATIENT,
} from "@/containers/Dashboard/Patient/schema/PatientProfileInfoSchema";
import { CustomForm } from "@/component-library/CustomForm";
import FormikInput from "@/components/UI/FormikInput";
import FormikMobileInput from "@/components/UI/formikMobileInput";
import Hr from "@/components/UI/Hr";
import { isUserAdmin, isUserPatient } from "@/utils/authToken";
import {
  PATIENT_VALIDATION_SCHEMA,
  VALIDATION_SCHEMA,
} from "@/containers/Dashboard/Patient/schema/PatientProfileValidation";

import PatientProfileDetailsCard from "./PatientProfileDetailsCard";
import { renderTitleWithValue } from "./renderTitleWithValue";
import SubmitControls from "./SubmitControls";

class ProfileBasicInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.edit,
      editableData: null,
    };
  }

  componentDidMount() {
    let profileData = this.props.data;

    if (isUserAdmin()) {
      profileData = this.transformDOBsToValidStrings(profileData);
    }

    this.setState({
      editableData: profileData,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      let profileData = this.props.data;

      if (isUserAdmin()) {
        profileData = this.transformDOBsToValidStrings(profileData);
      }

      this.setState({
        editableData: profileData,
      });
    }
  }

  toggleEditBasicInfo = () => {
    this.setState((ps) => {
      return {
        edit: !ps.edit,
      };
    });
  };

  renderBasicForm = (formikProps) => {
    let schema = PATIENT_BASIC_SCHEMA;

    if (!isUserPatient()) {
      schema = BASIC_SCHEMA;
    }

    return (
      <Form>
        <div className="mx-auto px-0">
          <div className="container px-0">
            <div className="row">
              {schema.map((formEl) => {
                if (formEl.elementType === "segment") {
                  return (
                    <h6 className="col-12" key={formEl.displayName}>
                      <b>{formEl.displayName}</b>
                    </h6>
                  );
                } else if (formEl.elementType === "readOnly") {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      <FormikInput
                        disabled
                        errors={formikProps.errors}
                        formEl={formEl}
                        inputBorderDisabled="border-0 px-0"
                        touched={formikProps.touched}
                      />
                    </div>
                  );
                } else {
                  return (
                    <div className="col-12 col-lg-6" key={formEl.name}>
                      {formEl.name === "email" && this.state.edit ? (
                        <FormikInput
                          disabled
                          errors={formikProps.errors}
                          formEl={formEl}
                          inputBorderDisabled="border-0 px-0"
                          touched={formikProps.touched}
                        />
                      ) : formEl.name == "mobile" ? (
                        <FormikMobileInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          onChange={async (val) => {
                            await formikProps.setFieldValue("mobile", val.value);
                            formikProps.setFieldTouched("mobile");
                          }}
                          touched={formikProps.touched}
                          value={formikProps && formikProps.values.mobile}
                        />
                      ) : formEl.name == "dob" ? (
                        <FormikMobileInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          onChange={async (val) => {
                            await formikProps.setFieldValue("dob", val.value);
                            formikProps.setFieldTouched("dob");
                          }}
                          touched={formikProps.touched}
                          value={formikProps && formikProps.values.dob}
                        />
                      ) : (
                        <FormikInput
                          errors={formikProps.errors}
                          formEl={formEl}
                          touched={formikProps.touched}
                        />
                      )}
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>

        <div className="mb-3 d-lg-none">
          <Hr />
        </div>

        <SubmitControls cancelHandler={this.toggleEditBasicInfo} />
      </Form>
    );
  };

  alteredFormData = (data) => {
    let alteredData = { ...data };

    let DOBnumber = {
      dob: alteredData.dob,
    };

    DOBnumber = {
      dob: `${DOBnumber.dob.substring(0, 2)}/${DOBnumber.dob.substring(
        2,
        4,
      )}/${DOBnumber.dob.substring(4, 8)}`,
    };

    return DOBnumber;
  };

  transformDOBsToValidStrings = (data) => {
    let updatedData = { ...data };

    if (Object.hasOwn(updatedData, "dob")) {
      updatedData["dob"] = updatedData["dob"].replace(/\//g, "");
    }

    return updatedData;
  };

  submitHandler = (formData, action) => {
    let newFormData = { ...formData };

    if (isUserAdmin()) {
      let newDOBData = this.alteredFormData(formData);

      newFormData.dob = newDOBData.dob;
    }
    let data = { ...newFormData };

    this.setState((ps) => {
      return {
        edit: !ps.edit,
        editableProfileData: null,
      };
    });
    this.props.submit(data, action);
  };

  render = () => {
    let validationSchema = VALIDATION_SCHEMA;

    if (!isUserAdmin()) {
      validationSchema = PATIENT_VALIDATION_SCHEMA;
    }

    return (
      <PatientProfileDetailsCard
        classes={this.props.classes}
        edit={this.state.edit}
        heading="Basic Information"
        isEditable
        onclick={this.toggleEditBasicInfo}
        type="Edit"
      >
        <div className="PatientProfile__basic-info no-gutters row pt-2">
          {!this.state.edit &&
            iterableBasicInfo(this.props.data).map((item) => {
              return (
                <div className="col-12 col-lg-6" key={item.title}>
                  {renderTitleWithValue(item.title, item.value, item.subtitle, item.optional)}
                </div>
              );
            })}

          {this.state.edit && (
            <CustomForm
              initialValues={this.state.editableData}
              onSubmit={this.submitHandler}
              render={this.renderBasicForm}
              validationSchema={validationSchema}
            />
          )}
        </div>
      </PatientProfileDetailsCard>
    );
  };
}

export default ProfileBasicInfo;

export const iterableBasicInfo = (profileData) => [
  { title: "Legal First Name", value: profileData.first_name || "" },
  { title: "Legal Last Name", value: profileData.last_name || "" },
  {
    optional: true,
    subtitle: PREFERRED_NAME_SCHEMA_PATIENT.elementConfig.subtext,
    title: PREFERRED_NAME_SCHEMA_PATIENT.elementConfig.label,
    value: profileData.preferred_name || "",
  },
  { optional: true, title: "Preferred Pronouns", value: profileData.preferred_pronouns || "" },
  { title: "Date of Birth", value: profileData.dob || "" },
  { title: "Gender", value: profileData.gender || "" },
  { title: "Mobile", value: profileData.mobile || "" },
  { title: "Email", value: profileData.email || "" },
  { title: "Street", value: profileData.address.street || "" },
  { title: "State", value: profileData.address.state || "" },
  { title: "City", value: profileData.address.city || "" },
  { title: "Zip", value: profileData.address.zip_code || "" },
];
